export default "__VITE_ASSET__C870Td8i__"